// A document being written keeps itself in the browser.
//
// The landing composer is an editor in a loop — write, preview, write again — and the document is
// the whole of what the visitor has: there is no account, no address, nothing on the server. Losing
// it to a closed tab is losing the work. So a field marked `data-keep-draft="<key>"` is saved to
// localStorage as it is typed, and put back when the page opens on nothing but its example.
//
// localStorage and not sessionStorage, unlike tinyform/draft.js: a half-filled form dies with its
// tab by design (a shared machine), a document one is writing is meant to be found again. And a
// plain per-origin key, not the browser store of /my-data: that store lists what it holds, and a
// draft is not a record — it is where the visitor left off, on this page.
//
// The page says whether it opened FRESH (`data-keep-draft-fresh`): on a fresh page a kept draft
// replaces the example and a notice says so, with a way back to the example; after a preview the
// field holds what was just submitted, which becomes the draft — never the other way round.

const PREFIX = 'arcate:draft:';

function storage() {
	try {
		return window.localStorage;
	} catch (ignored) {
		return null;
	}
}

document.querySelectorAll('[data-keep-draft]').forEach((holder) => {
	const field = holder.querySelector('textarea, input');
	const store = storage();
	if (!field || !store) return;

	const key = PREFIX + holder.dataset.keepDraft;
	const example = field.value;
	const notice = holder.querySelector('[data-keep-draft-notice]');
	const reset = holder.querySelector('[data-keep-draft-reset]');

	const save = () => {
		try {
			if (field.value.trim() && field.value !== example) {
				store.setItem(key, field.value);
			} else {
				store.removeItem(key);
			}
		} catch (ignored) {
			// A full or refused storage loses a draft, which is a nuisance, not a failure.
		}
	};

	if (holder.dataset.keepDraftFresh === 'true') {
		const kept = store.getItem(key);
		if (kept && kept !== example) {
			field.value = kept;
			if (notice) notice.hidden = false;
		}
	} else {
		save();
	}

	let timer = null;
	field.addEventListener('input', () => {
		window.clearTimeout(timer);
		timer = window.setTimeout(save, 300);
	});

	if (reset) {
		reset.addEventListener('click', () => {
			field.value = example;
			try {
				store.removeItem(key);
			} catch (ignored) {
				// see save()
			}
			if (notice) notice.hidden = true;
			field.focus();
		});
	}
});
